import { Component, OnInit, Input } from '@angular/core';
import { TournamentService } from "../../services/tournament.service";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmModalComponent } from "../confirm-modal/confirm-modal.component";

@Component({
  selector: 'app-tournament-status',
  templateUrl: './tournament-status.component.html',
  styleUrls: ['./tournament-status.component.scss']
})
export class TournamentStatusComponent implements OnInit {
  @Input() tournamentId: number = -1;
  @Input() tournamentStatus: string = '';

  public status_name = {
    registration: 'Открыта регистрация',
    registration_closed: 'Регистрация завершена',
    in_progress: 'Идет',
    finished: 'Завершен',
  };

  public available_statuses = [
    'registration',
    'registration_closed',
    'in_progress',
    'finished',
  ];

  public errorStatus: string;
  public tournamentErrorStatus: string;
  public newTournamentId: number;

  constructor(
    private tournamentService: TournamentService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void { }

  sendStatus($event) {
    this.tournamentService.updateStatus(this.tournamentId, $event.target.value).subscribe((res) => {
      if (res['message'] == 'error') {
        this.errorStatus = res['detail'];
      }
    });
  }

  assignStatus($event) {
    if ($event.target.value == 'finished') {
      const modalRef = this.modalService.open(ConfirmModalComponent, {
        size: 'md',
        windowClass: 'testModalStyle',
        centered: true,
      });
      modalRef.componentInstance.message = 'Вы уверены, что хотите завершить турнир?';
      modalRef.result.then((result) => {
        if (result) {
          this.sendStatus($event);
        }
      });
    }
    else {
      this.sendStatus($event);
    }
  }

  get_status_name(status: string) {
    return this.status_name[status];
  }

  get_available_statuses() {
    if (this.tournamentStatus == 'registration')
      return this.available_statuses;
    return this.available_statuses.slice(1);
  }

  checkStatusError() {
    if (this.errorStatus == 'Bracket is already formed, you cannot switch to that status!') {
      return 'Сетка уже сформирована, вы не можете установить данный статус';
    }
    else if (this.errorStatus == 'This status is already set!') {
      return 'Данный статус уже установлен';
    }
    else if (this.errorStatus) {
      return 'Произошла ошибка при редактировании статуса турнира';
    }
    return '';
  }

  createCopyTournament() {
    this.tournamentService.createCopy(this.tournamentId).subscribe((res) => {
      if (res['message'] == 'error') {
        this.tournamentErrorStatus = res['detail'];
      }
      if (res['message'] == 'ok') {
        this.newTournamentId = res['new_id'];
      }
    });
  }

  checkCopyError() {
    if (this.tournamentErrorStatus) {
      return 'Турнир не был скопирован';
    }
    return '';
  }

  checkCopySuccess() {
    if (this.newTournamentId) {
      return 'Турнир был успешно скопирован';
    }
    return '';
  }

}
